import React from 'react';
import './DrawerToggleButton.scss';

const drawerToggleButton = ({ open, clicked }) => {
  return (
    <div
      className={open ? 'toggle-button-open' : 'toggle-button'}
      onClick={clicked}>
      <div className="line-1" />
      <div className="line-2" />
      <div className="line-3" />
    </div>
  );
};

export default drawerToggleButton;
